export const PARTNER_CATEGORIES = [
  'Ristoranti', 'Escursioni', 'Tour', 'Noleggi', 'Spiagge',
  'Musei', 'Wine Experience', 'Servizi', 'Shopping',
];
